export type ClusterGroup = 'rsu' | 'pmv' | 'spatem' | 'denm' | 'ivim';

export type RsuClusterStatus = 'up' | 'warning' | 'error' | 'down' | 'unknown' | 'agg';
export type PmvClusterStatus = 'working' | 'not-working';
export type SpatemClusterStatus = 'active' | 'inactive';
export type DenmClusterStatus = 'progress' | 'disabled' | 'terminated';
export type IvimClusterStatus = 'progress' | 'disabled' | 'scheduled' | 'terminated';

export type ClusterStatus =
  | RsuClusterStatus
  | PmvClusterStatus
  | SpatemClusterStatus
  | DenmClusterStatus
  | IvimClusterStatus;

export interface ClusterMarkerMeta {
  group: ClusterGroup;
  status: ClusterStatus;
}

export interface ClusterChip {
  group: ClusterGroup;
  status: ClusterStatus;
  count: number;
  iconUrl: string;
  /** Use white circular background (DENM/IVIM mono style). */
  fullContainer?: boolean;
  /** Optional accent for status-tinted chip background. */
  accentColor?: string;
}

export const CLUSTER_GROUP_ORDER: ClusterGroup[] = ['rsu', 'pmv', 'spatem', 'denm', 'ivim'];

export const CLUSTER_STATUS_ORDER: Record<ClusterGroup, readonly string[]> = {
  rsu: ['error', 'down', 'warning', 'unknown', 'agg', 'up'],
  pmv: ['not-working', 'working'],
  spatem: ['active', 'inactive'],
  denm: ['progress', 'disabled', 'terminated'],
  ivim: ['progress', 'scheduled', 'disabled', 'terminated'],
};

export const EVENT_STATUS_COLORS: Record<string, string> = {
  scheduled: '#b900ff',
  progress: '#4fca4f',
  terminated: '#42414b',
  disabled: '#ffa500',
};
